import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    profile: null,
    menu: null,
    sidebarList: [],
    errorData: {},
    reload: false,
    unSavedChangesData: {
        isFilledForm: false,
        isClickAnotherPage: false,
        isShowConfirm: false,
        urlNavigate: '',
    },
}

export const homeSlice = createSlice({
    name: 'profile',
    initialState: initialState,
    reducers: {
        setProfile: (state, action) => {
            state.profile = { ...state.profile, ...action.payload }
        },
        setMenu: (state, action) => {
            state.menu = { ...state.menu, ...action.payload }
        },
        setSidebarList: (state, action) => {
            state.sidebarList = [...action.payload]
        },
        setErrorData: (state, action) => {
            state.errorData = { ...state.errorData, ...action.payload }
        },
        setReloadMenu: (state) => ({
            ...state,
            reload: !state.reload,
        }),
        setUnSavedChangesData: (state, action) => {
            state.unSavedChangesData = { ...state.unSavedChangesData, ...action.payload }
        },
    },
})

export const { setProfile, setMenu, setSidebarList, setErrorData, setReloadMenu, setUnSavedChangesData } =
    homeSlice.actions

const homeReducer = homeSlice.reducer
export default homeReducer
